import { ActivityEventDto } from '../../../shared/modules/activity/dtos/activity-event.dto';
import { VehicleCategoryActivityEventHydration } from './vehicle-category-activity-event-hydration.dto';

/**
 * A vehicle category activity event with hydrated related records.
 */
export class VehicleCategoryActivityEventDto extends ActivityEventDto {
  hydrated?: VehicleCategoryActivityEventHydration;
}
